import { render, staticRenderFns } from "./ClientsNavItem.vue?vue&type=template&id=13948616"
import script from "./ClientsNavItem.vue?vue&type=script&lang=js"
export * from "./ClientsNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports